import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Monitor, Users, MessageSquare, Wifi } from "lucide-react";

const WystepOnline = () => (
  <SeoPageLayout title="Występ komediowy" titleAccent="online">
    <SeoSection title="Stand-up online - komedia na żywo przez Internet">
      <p>Występ komediowy online to nowoczesna forma rozrywki firmowej, która pozwala zintegrować zespoły rozproszone po całym kraju lub świecie. Nasi komicy prowadzą interaktywne show na żywo przez platformy takie jak Zoom, Teams czy Google Meet - z pełnym kontaktem z publicznością, reakcjami na czacie i angażującymi elementami interaktywnymi.</p>
    </SeoSection>
    <SeoSection title="Kiedy sprawdza się występ online?">
      <SeoStyledList items={[
        "Zespoły pracujące zdalnie lub w modelu hybrydowym",
        "Firmy z oddziałami w różnych miastach lub krajach",
        "Integracja międzynarodowych zespołów",
        "Szybkie, niskobudżetowe eventy integracyjne",
        "Świąteczne spotkania firmowe online",
        "Konferencje i webinary wymagające przerwy rozrywkowej"
      ]} />
    </SeoSection>
    <SeoSection title="Jak wygląda występ online?">
      <SeoFeatureGrid features={[
        { icon: Monitor, title: "Transmisja na żywo", description: "Zoom, Teams, Google Meet - dowolna platforma" },
        { icon: MessageSquare, title: "Interakcja na czacie", description: "Pytania do publiczności i reakcje w czasie rzeczywistym" },
        { icon: Users, title: "Personalizacja", description: "Spersonalizowane żarty nawiązujące do Twojej firmy" },
        { icon: Wifi, title: "Profesjonalny setup", description: "Oświetlenie, dźwięk i stabilne połączenie" },
      ]} />
    </SeoSection>
    <SeoSection title="Zamów występ komediowy online">
      <p>Niezależnie od tego, gdzie znajduje się Twój zespół - możemy dostarczyć dawkę śmiechu i pozytywnej energii. Skontaktuj się z nami, a zaproponujemy format idealnie dopasowany do Twoich potrzeb i platformy, z której korzystacie.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepOnline;
